// src/internal/constants/dimensions.ts
var SIDEBAR_DRAWER_SIZE = {
  sm: "100%",
  lg: "184px",
  collapsed: "56px"
};

export {
  SIDEBAR_DRAWER_SIZE
};
